document.addEventListener('DOMContentLoaded', () => {
  function clickableSectionItems() {
    const items = document.querySelectorAll('.item--clickable');
    items.forEach(el => {
      el.addEventListener('click', (e) => {
        if (e.target.dataset.link && !isTouchDevice()) {
          window.location.href = e.target.dataset.link;
        }
      });
    });

    const disabledOnMobileLinks = document.querySelectorAll('.link--mobile-disabled');
    disabledOnMobileLinks.forEach(link => {
      if (isTouchDevice()) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
        });
      }
    });
  }
  clickableSectionItems();

  function isTouchDevice() {
    return (('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0));
  }
})